module.exports = __webpack_public_path__ + "static/media/SellkeyMain01.1bb772b4.png";